import BoxColorWrapper from "./BoxColorWrapper";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

const styles = {
  div1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "10px",
    minHeight: "1.1em",
  },
};

export default function CommentContainer(props) {
  const keikkaData = props.keikkaData;
  const rows = props.rows;

  return (
    <BoxColorWrapper alignItems="left">
      <div style={styles.div1}>
        <Typography variant="body" color="primary">
          {keikkaData.keikkaOtsikko}
        </Typography>
        <Typography noWrap={rows < 4} variant="body2" color="primary">
          {keikkaData.keikkaComment}
        </Typography>
      </div>
    </BoxColorWrapper>
  );
}

CommentContainer.propTypes = {
  keikkaData: PropTypes.object,
  rows: PropTypes.number,
};
